import React, { useEffect, useContext } from "react";
import Zoom from "react-reveal/Zoom";
import Slide from "react-reveal/Slide";
import Fade from "react-reveal/Fade";
import { NavContext } from "../Contexts/NavContext";
import "../css/Contact.css";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";

import "../css/main.css";

const Contact = () => {
	const { setInd } = useContext(NavContext);
	useEffect(() => {
		setInd(2);
	});

	const contactMethods = [
		{
			//whatsapp
			image: (
				<svg fill="#000000" viewBox="0 0 24 24" width="384px" height="384px">
					<path d="M19.077,4.928C17.191,3.041,14.683,2.001,12.011,2c-5.506,0-9.987,4.479-9.989,9.985 c-0.001,1.76,0.459,3.478,1.333,4.992L2,22l5.233-1.237c1.459,0.796,3.101,1.215,4.773,1.216h0.004 c5.505,0,9.986-4.48,9.989-9.985C22.001,9.325,20.963,6.816,19.077,4.928z M16.898,15.554c-0.208,0.583-1.227,1.145-1.685,1.186 c-0.458,0.042-0.887,0.207-2.995-0.624c-2.537-1-4.139-3.601-4.263-3.767c-0.125-0.167-1.019-1.353-1.019-2.581 S7.581,7.936,7.81,7.687c0.229-0.25,0.499-0.312,0.666-0.312c0.166,0,0.333,0,0.478,0.006c0.178,0.007,0.375,0.016,0.562,0.431 c0.222,0.494,0.707,1.728,0.769,1.853s0.104,0.271,0.021,0.437s-0.125,0.27-0.249,0.416c-0.125,0.146-0.262,0.325-0.374,0.437 c-0.125,0.124-0.255,0.26-0.11,0.509c0.146,0.25,0.646,1.067,1.388,1.728c0.954,0.85,1.757,1.113,2.007,1.239 c0.25,0.125,0.395,0.104,0.541-0.063c0.146-0.166,0.624-0.728,0.79-0.978s0.333-0.208,0.562-0.125s1.456,0.687,1.705,0.812 c0.25,0.125,0.416,0.187,0.478,0.291C17.106,14.471,17.106,14.971,16.898,15.554z" />
				</svg>
			),
			link: "https://wa.me/+2347017271571?text=Hello%20Elijah!%20I'm%20interested%20in%20working%20with%you.",
		},
		{
			//GitHub
			image: (
				<svg fill="#000000" viewBox="0 0 30 30" width="240px" height="240px">
					<path d="M15,3C8.373,3,3,8.373,3,15c0,5.623,3.872,10.328,9.092,11.63C12.036,26.468,12,26.28,12,26.047v-2.051 c-0.487,0-1.303,0-1.508,0c-0.821,0-1.551-0.353-1.905-1.009c-0.393-0.729-0.461-1.844-1.435-2.526 c-0.289-0.227-0.069-0.486,0.264-0.451c0.615,0.174,1.125,0.596,1.605,1.222c0.478,0.627,0.703,0.769,1.596,0.769 c0.433,0,1.081-0.025,1.691-0.121c0.328-0.833,0.895-1.6,1.588-1.962c-3.996-0.411-5.903-2.399-5.903-5.098 c0-1.162,0.495-2.286,1.336-3.233C9.053,10.647,8.706,8.73,9.435,8c1.798,0,2.885,1.166,3.146,1.481C13.477,9.174,14.461,9,15.495,9 c1.036,0,2.024,0.174,2.922,0.483C18.675,9.17,19.763,8,21.565,8c0.732,0.731,0.381,2.656,0.102,3.594 c0.836,0.945,1.328,2.066,1.328,3.226c0,2.697-1.904,4.684-5.894,5.097C18.199,20.49,19,22.1,19,23.313v2.734 c0,0.104-0.023,0.179-0.035,0.268C23.641,24.676,27,20.236,27,15C27,8.373,21.627,3,15,3z" />
				</svg>
			),
			link: "https://github.com/elijahthis",
		},
		{
			//LinkedIn
			image: (
				<svg fill="#000000" viewBox="0 0 30 30" width="240px" height="240px">
					<path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M10.954,22h-2.95 v-9.492h2.95V22z M9.449,11.151c-0.951,0-1.72-0.771-1.72-1.72c0-0.949,0.77-1.719,1.72-1.719c0.948,0,1.719,0.771,1.719,1.719 C11.168,10.38,10.397,11.151,9.449,11.151z M22.004,22h-2.948v-4.616c0-1.101-0.02-2.517-1.533-2.517 c-1.535,0-1.771,1.199-1.771,2.437V22h-2.948v-9.492h2.83v1.297h0.04c0.394-0.746,1.356-1.533,2.791-1.533 c2.987,0,3.539,1.966,3.539,4.522V22z" />
				</svg>
			),
			link: "https://www.linkedin.com/in/elijah-oyerinde-070a24215/",
		},
		{
			// Twitter
			image: (
				<svg fill="#000000" viewBox="0 0 50 50" width="500px" height="500px">
					<path d="M 50.0625 10.4375 C 48.214844 11.257813 46.234375 11.808594 44.152344 12.058594 C 46.277344 10.785156 47.910156 8.769531 48.675781 6.371094 C 46.691406 7.546875 44.484375 8.402344 42.144531 8.863281 C 40.269531 6.863281 37.597656 5.617188 34.640625 5.617188 C 28.960938 5.617188 24.355469 10.21875 24.355469 15.898438 C 24.355469 16.703125 24.449219 17.488281 24.625 18.242188 C 16.078125 17.8125 8.503906 13.71875 3.429688 7.496094 C 2.542969 9.019531 2.039063 10.785156 2.039063 12.667969 C 2.039063 16.234375 3.851563 19.382813 6.613281 21.230469 C 4.925781 21.175781 3.339844 20.710938 1.953125 19.941406 C 1.953125 19.984375 1.953125 20.027344 1.953125 20.070313 C 1.953125 25.054688 5.5 29.207031 10.199219 30.15625 C 9.339844 30.390625 8.429688 30.515625 7.492188 30.515625 C 6.828125 30.515625 6.183594 30.453125 5.554688 30.328125 C 6.867188 34.410156 10.664063 37.390625 15.160156 37.472656 C 11.644531 40.230469 7.210938 41.871094 2.390625 41.871094 C 1.558594 41.871094 0.742188 41.824219 -0.0585938 41.726563 C 4.488281 44.648438 9.894531 46.347656 15.703125 46.347656 C 34.617188 46.347656 44.960938 30.679688 44.960938 17.09375 C 44.960938 16.648438 44.949219 16.199219 44.933594 15.761719 C 46.941406 14.3125 48.683594 12.5 50.0625 10.4375 Z" />
				</svg>
			),
			link: "https://twitter.com/elijahthis",
		},
		{
			//email
			image: (
				<svg data-name="Layer 1" viewBox="0 0 119.45 122.88">
					<path d="M0,58.68V53.56L39.82,88.38.52,119.18A6.14,6.14,0,0,1,0,116.71v-58Zm82-6a24,24,0,0,1-1,6.19,15.32,15.32,0,0,1-2.48,4.85,10.89,10.89,0,0,1-3.83,3.18A11.09,11.09,0,0,1,69.83,68a8.69,8.69,0,0,1-2.13-.25A7.6,7.6,0,0,1,65.79,67a6.7,6.7,0,0,1-1.58-1.21,6.8,6.8,0,0,1-.69-.82,8.54,8.54,0,0,1-6.69,2.92,8,8,0,0,1-2.52-.39,7.53,7.53,0,0,1-2.19-1.19l0,0a7.89,7.89,0,0,1-1.71-1.88,10.11,10.11,0,0,1-1.19-2.52v0a15.7,15.7,0,0,1-.55-6.27v0a23.36,23.36,0,0,1,1.46-5.95,16.59,16.59,0,0,1,2.83-4.71,12.06,12.06,0,0,1,4-3.09,11.11,11.11,0,0,1,4.79-1,14.3,14.3,0,0,1,3.67.45,11.15,11.15,0,0,1,3.17,1.39l1.63,1.09a.65.65,0,0,1,.28.59L69.11,59.36a3.29,3.29,0,0,0,.29,2.22,1.75,1.75,0,0,0,1.54.61,2.63,2.63,0,0,0,1.61-.56A5.63,5.63,0,0,0,74,59.74a12,12,0,0,0,1.09-3,20.78,20.78,0,0,0,.47-3.83,24.13,24.13,0,0,0-.65-7.4,13.59,13.59,0,0,0-2.76-5.39,11.76,11.76,0,0,0-4.67-3.32A17.51,17.51,0,0,0,61,35.68a16.06,16.06,0,0,0-4.45.6,14.57,14.57,0,0,0-3.91,1.79A15.31,15.31,0,0,0,49.32,41a18.56,18.56,0,0,0-2.54,3.93,24,24,0,0,0-1.69,4.76,29.77,29.77,0,0,0-.74,5.42h0A25.78,25.78,0,0,0,45,62.81a14,14,0,0,0,2.77,5.57,11.75,11.75,0,0,0,4.76,3.38,18.42,18.42,0,0,0,6.77,1.15,19.82,19.82,0,0,0,2.16-.12c.74-.08,1.51-.21,2.28-.37s1.48-.33,2.12-.52a15.05,15.05,0,0,0,1.7-.61.64.64,0,0,1,.84.34.55.55,0,0,1,0,.17L69.41,76a.67.67,0,0,1-.28.68,10.53,10.53,0,0,1-2,1,17.2,17.2,0,0,1-2.47.76,23.7,23.7,0,0,1-2.73.49,23.18,23.18,0,0,1-2.75.16,24.74,24.74,0,0,1-12.17-2.77,16.89,16.89,0,0,1-4.39-3.45,18.16,18.16,0,0,1-3.09-4.79l0,0a24,24,0,0,1-1.73-5.95A35.46,35.46,0,0,1,37.41,55a32.6,32.6,0,0,1,1-6.86,28,28,0,0,1,2.36-6.12A23.13,23.13,0,0,1,44.37,37a21.6,21.6,0,0,1,4.74-3.82,22.27,22.27,0,0,1,5.65-2.37A24.52,24.52,0,0,1,61.07,30a22.8,22.8,0,0,1,11.5,2.77,17.53,17.53,0,0,1,4.28,3.4,18.32,18.32,0,0,1,3,4.59,22.32,22.32,0,0,1,1.76,5.6A28.62,28.62,0,0,1,82,52.71Zm-25.7,3a15.3,15.3,0,0,0,0,2.79,5.85,5.85,0,0,0,.48,1.9,2.42,2.42,0,0,0,.83,1,2.13,2.13,0,0,0,1.19.32,2.1,2.1,0,0,0,.89-.2,3.08,3.08,0,0,0,.87-.67,5.64,5.64,0,0,0,.83-1.17,10.13,10.13,0,0,0,.69-1.58l1-11-.17,0a5.62,5.62,0,0,0-.74,0,5,5,0,0,0-2.25.49A4.51,4.51,0,0,0,58.27,49a9.45,9.45,0,0,0-1.2,2.7,23.81,23.81,0,0,0-.73,4ZM.15,43.47C1,40.14,5.72,38,8.34,36.14V21.85a6,6,0,0,1,6-6H36.81L58.26.57A3.24,3.24,0,0,1,62,.59L83.08,15.85h22a6,6,0,0,1,6,6V36.1c2.82,2,8.34,4.72,8.34,8.49v.15L105.11,56.83v-35H14.34v34L.15,43.47Zm119.3,11.31v61.93a6.12,6.12,0,0,1-1.42,3.93L78.34,89.43l41.11-34.65Zm-11,68.1H8.26L45.71,93.53l11.15,9.75a3.83,3.83,0,0,0,5.15-.09L72.33,94.5l36.09,28.38Z" />
				</svg>
			),
			link: "mailto:hello@elijahthis.com?subject=I'd Love to Work with You!",
		},
	];

	const sendEmail = (ev) => {
		ev.preventDefault();
		emailjs
			.sendForm(
				"service_v8eywx6",
				"template_z9u9fue",
				ev.target,
				"user_3IGxYKsaWpDLDtc6FaRt6"
			)
			.then(
				(result) => {
					console.log(result.text);
				},
				(error) => {
					console.log(error.text);
				}
			);
		ev.target.reset();
	};
	return (
		<>
			<section className="contact-section" id="Contact" name="Contact">
				<Fade bottom duration={700}>
					<h2>Work with me!</h2>
				</Fade>
				<Fade bottom duration={700} delay={700}>
					<p className="collab">
						Do you have a question, proposal or idea you would like us to
						collaborate on? Hit me up...
					</p>
				</Fade>
				<form onSubmit={sendEmail}>
					<div>
						<Fade bottom duration={700} delay={1400}>
							<label>
								Name
								<input
									type="text"
									name="from_name"
									placeholder="What's your name?"
									required
								/>
							</label>
						</Fade>
						<Fade bottom delay={1900}>
							<label>
								Email Address
								<input
									type="email"
									name="from_email"
									placeholder="What's your email address?"
									required
								/>
							</label>
						</Fade>
					</div>
					<Fade bottom delay={2400}>
						<div>
							<label>
								Message
								<textarea
									style={{ height: "100px" }}
									name="message"
									placeholder="Hello. I'd love to work with you!"
									required
								></textarea>
							</label>
						</div>
					</Fade>
					<Fade bottom delay={2900}>
						<span className="btn">
							<div style={{ margin: 0 }}>Send Message</div>
							<svg
								x="0px"
								y="0px"
								viewBox="0 0 1000 1000"
								enableBackground="new 0 0 1000 1000"
								xmlSpace="preserve"
							>
								<g>
									<g transform="matrix(1 0 0 -1 0 1008)">
										<path d="M756.2,741.8L990,508L756.2,274.2l-27,27L918.1,490H10v36h908.1L729.3,714.8L756.2,741.8z" />
									</g>
								</g>
							</svg>
							<input type="submit" name="submit" value="Send Message" />
						</span>
					</Fade>
				</form>
				<Slide bottom delay={3000} duration={400}>
					<div className="contacts">
						{contactMethods.map((method, i) => (
							<a href={method.link} target="_blank" rel="noreferrer" key={i}>
								<div>{method.image}</div>
							</a>
						))}
					</div>
				</Slide>

				{/* <Link to="#interests">
                    <div className="nav-arrow">
                        <svg
                            width="6"
                            height="8"
                            style={{ transform: "scale(3)" }}
                        >
                            <path fill="none" d="M1 0l4 4-4 4" />
                        </svg>
                        <div className="dot"></div>
                    </div>
                </Link> */}
			</section>
		</>
	);
};

export default Contact;
